import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import _ from 'lodash'
import { RotatingLines } from "react-loader-spinner";
import { useAppDispatch } from "../../hooks/hooks";
import { Swiper, SwiperSlide } from "swiper/react";
import storePersist from "../../redux/storePersist";
import { getCardData } from "../../common/services/website-card.service";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import * as R from "ramda"
import ProgramCard from "./communities-cards.component";
import { selectCommunitiesCreatedItem, selectCommunitiesListItems, selectCommunitiesQueryItems } from "../../redux/community/selector";
import { communities } from "../../redux/community/action";
import { communitySubscriptions } from "../../redux/community-subscriptions/action";

export default function Communities() {
  const dispatch = useAppDispatch();
  const [topics, setTopics] = useState<any>([]);
  const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false)
  const statesItem = storePersist?.get("states")?.current?.items;
  const countriesItem = storePersist?.get("countries")?.current?.items;
  const communitiesList = useSelector(selectCommunitiesListItems);
  const listcommunities = useSelector(selectCommunitiesCreatedItem)


  const [selectedCommunities, setSelectedCommunities] = useState<any>({

  });

  const resetForm = () => {
    setSelectedCommunities({
      Login: {
        Phone: "",
        Email: ""
      },
      UserProfile: {
        FirstName: "",
        LastName: "",
        PersonTitle: ""
      },
      ONEUserInfo: {
        Biography: null,
        PhotoUrl: null,
        IsONEUserVerified: true,
        StartupName: "",
        YearsInOperation: "",
        IsTechFirstInnovation: true,
        StageOfTheStartup: "",
        Sector: "",
        WebsiteLink: "",
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        utm_term: null,
        utm_content: null
      },
      Account: {
        IsPersonAccount: true,
        Name: "",
        TypeId: ""
      },
      PrimaryAddress: {
        address1: "",
        address2: "",
        city: "",
        CountryId: "",
        StateProvinceId: "",
        ZipPostalCode: "",
      }
    });
  };
  useEffect(() => {
    if (listcommunities?.isSuccess) {
      dispatch(communitySubscriptions.resetAction({ actionType: 'create' }))
      dispatch(communitySubscriptions.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/subscriptions`,
        entity: 'programs',
        jsonData: {
          "Context": {},
          Records: [
            {

              "Email": selectedCommunities?.Login?.Email,
              "PhoneNumber": selectedCommunities?.Login?.Phone,
              "OwnerType": "onecommunities",
              "CommunityId": selectedCommunities?.CommunityId,
              "IsExistingUser": selectedCommunities?.IsExistingUser || false,

            }
          ]
        }

      }))
      resetForm();

      dispatch(communities.resetAction({ actionType: 'create' }))
    }
  }, [listcommunities]);

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const data = {
      "Login": {
        "Phone": selectedCommunities?.Login?.Phone,
        "Email": selectedCommunities?.Login?.Email,
      },

      "UserProfile": {
        "FirstName": selectedCommunities?.UserProfile?.FirstName,
        "LastName": "",
        "PersonTitle": ""
      },
      "ONEUserInfo": {
        "Biography": null,
        "PhotoUrl": null,
        "IsONEUserVerified": true,
        "StartupName": selectedCommunities?.ONEUserInfo?.StartupName,
        "YearsInOperation": "",
        "IsTechFirstInnovation": true,
        "StageOfTheStartup": selectedCommunities?.ONEUserInfo?.StageOfTheStartup,
        "Sector": selectedCommunities?.ONEUserInfo?.Sector,
        "WebsiteLink": selectedCommunities?.PrimaryAddress?.WebsiteLink,
        "utm_source": null,
        "utm_medium": null,
        "utm_campaign": null,
        "utm_term": null,
        "utm_content": null
      },

      "Account": {
        "IsPersonAccount": true,
        "Name": "ONE User 001",
        "TypeId": 440
      },

      "PrimaryAddress": {
        "address1": selectedCommunities?.PrimaryAddress?.address1,
        "address2": selectedCommunities?.PrimaryAddress?.address2,
        "city": selectedCommunities?.PrimaryAddress?.city,
        "CountryId": selectedCommunities?.PrimaryAddress?.CountryId,
        "StateProvinceId": selectedCommunities?.PrimaryAddress?.StateProvinceId,
        "ZipPostalCode": selectedCommunities?.PrimaryAddress?.ZipPostalCode,
      }




    }
    if (!selectedCommunities?.IsExistingUser) {
      await dispatch(communities.resetAction({ actionType: 'create' }))
      await dispatch(communities.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-users`,
        entity: 'register',
        jsonData: {
          records: [
            data
          ]
        }
      }))
      await resetForm();
    } else {
      dispatch(communitySubscriptions.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/subscriptions`,
        entity: 'programs',
        jsonData: {
          "Context": {},
          Records: [
            {

              "Email": selectedCommunities?.Email,
              "PhoneNumber": selectedCommunities?.Phone,
              "OwnerType": "onecommunities",
              "CommunityId": selectedCommunities?.CommunityId,
              "IsExistingUser": selectedCommunities?.IsExistingUser || false,

            }
          ]
        }

      }))
      await resetForm();
    }
  }



  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedCommunities({ ...selectedCommunities, [fields[0]]: value });
  }

  const handleChange: any = (event: any, field: string) => {
    setSelectedCommunities({ ...selectedCommunities, [field]: event })

  }


  const dummyData = [{
    Id: 1,
    Name: "Community Name 1"
  },
  {
    Id: 2,
    Name: "Community Name 2"
  }, {
    Id: 3,
    Name: "Community Name 3"
  }, {
    Id: 4,
    Name: "Community Name 4"
  }, {
    Id: 5,
    Name: "Community Name 5"
  }]

  const dataToRender = communitiesList?.result?.items?.length > 0
    ? communitiesList.result.items
    : dummyData;



  useEffect(() => {
    dispatch(communities.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/community/communities/list`, entity: 'community',
      jsonData:
      {
        "Context": {
          "Subscription": "ONE",
          "Domain": "ONE",
          "SubDomains": [],
          "Network": "Internal",
          "Application": "Management",
          "Channel": "Portal"
        },
        "Records": [
          {
            "Id": 0
          }
        ],
      }
    }))
  }, [])

  useEffect(() => {
    if (communitiesList) {
      setTopics(communitiesList?.result?.items);
    }
  }, [communitiesList])


      const HomePageBannerData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONE_DIGIIT_COMMUNITY_MAIN_BANNER') : null;
      const banner: any = (HomePageBannerData && HomePageBannerData[0]?.src ? encodeURI(HomePageBannerData[0]?.src) : require('./../../assets/img/events.jpg'))

  const workProcessData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_WORK_PROCESS') : null;

  const eMobilityHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_E_MOBILITY_HEADING') : null;

  const eMobilityData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_E_MOBILITY') : null;

  const serviceHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_SERVICE_HEADING') : null;

  const serviceData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_SERVICE') : null;

  const copyRightsContent: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_COPYRIGHTS') : null;


  return (
    <>

      <div className="flex flex-col items-center justify-center w-full" style={{ backgroundImage: `url(${banner})` }}>
        <div className="flex justify-around items-center p-1 w-full h-[650px] px-10">
          {/* Left side text section */}
          <div className="flex p-2 flex-col justify-between items-center w-[800px]">
            {/* <p className="text-4xl font-normal text-white text-center">{CargoPageBannerData[0]?.title}</p>
                            <p className="text-xl pt-20 text-white text-center">{CargoPageBannerData[0]?.subTitle}</p> */}
            <p className="text-4xl font-normal text-white text-center"></p>
            <p className="text-xl pt-20 text-white text-center"></p>
          </div>

          {/* Right side form section */}
						<div className="w-1/3 flex justify-center items-start mt-20 rounded-2xl bg-white">
            <div className="w-full p-5 flex flex-col justify-center items-center rounded-2xl">
              <div className="text-2xl text-primary font-bold py-5">Community Subscription Form</div>
              <div className=" w-full px-3 font-bold space-y-2">


                <div className=" w-full px-3 font-bold space-y-2">
                  <div className=" w-full pt-2">
                    <div className="font-normal ">
                      <input
                        type="checkbox"
                        name="IsExistingUser"
                        checked={selectedCommunities?.IsExistingUser || false}
                        onChange={(event) => {
                          handleChange(event.target.checked, 'IsExistingUser');
                        }}
                        className="mr-2 w-4 h-4"
                      />
                      <label htmlFor="IsExistingUser" className="text-base">
                        Are you already registered?
                      </label>
                    </div>
                  </div>
                </div>
                {!selectedCommunities?.IsExistingUser && (
                  <div className="flex flex-row space-x-2 ">
                    <div className=" w-full pt-2">
                      <div className="font-normal ">
                        <input
                          required
                          type="text"
                          name={"FirstName"}
                          placeholder="Name"
                          className={`w-full py-3 px-3 border-b-2 border-black text-base`}
                          onChange={(event) => {
                            handleInnerFormChange(
                              event.target.value,
                              'UserProfile.FirstName',
                              selectedCommunities?.UserProfile
                            );
                          }}
                          value={selectedCommunities?.UserProfile?.FirstName} />
                      </div>
                    </div>
                  </div>
                )}
                {selectedCommunities?.IsExistingUser && (
                  <div className="flex flex-col space-y-2">


                    {!selectedCommunities?.Email && !selectedCommunities?.Phone && (
                      <label className="text-sm text-gray-700 font-medium mb-2">
                        Please enter <span className="text-blue-600 font-semibold">either your Email or Phone Number</span>
                      </label>
                    )}

                    <div className="flex flex-row space-x-2">

                      {!selectedCommunities?.Phone && (
                        <div className="w-full">
                          <div className="border-0 font-normal">
                            <label className="text-xs text-gray-600 pl-1">Email</label>
                            <input
                              required
                              type="email"
                              name="Email"
                              placeholder="Email"
                              className="w-full py-3 px-3 border-b-2 border-black text-base"
                              onChange={(event) => {
                                handleChange(event.target.value, 'Email');
                              }}
                              value={selectedCommunities?.Email}
                            />
                          </div>
                        </div>
                      )}


                      {!selectedCommunities?.Email && (
                        <div className="w-full">
                          <div className="border-0 font-normal">
                            <label className="text-xs text-gray-600 pl-1">Phone Number</label>
                            <input
                              required
                              maxLength={10}
                              type="text"
                              name="Phone"
                              placeholder="Phone Number"
                              pattern="\d{10}"
                              className="w-full py-3 px-3 border-b-2 border-black text-base"
                              onChange={(event) => {
                                handleChange(event.target.value.replace(/\D/g, ''), 'Phone');
                              }}
                              value={selectedCommunities?.Phone}
                            />
                            {selectedCommunities?.Phone?.length > 0 &&
                              selectedCommunities?.Phone?.length < 10 && (
                                <span className="text-red-600 text-xs">
                                  Please enter a valid number.
                                </span>
                              )}
                          </div>
                        </div>
                      )}

                    </div>
                  </div>

                )}
                {!selectedCommunities?.IsExistingUser && (
                  <div className="flex flex-row space-x-2 ">
                    <div className=" w-full">

                      <div className="border-0 font-normal">
                        <input
                          required
                          type="email"
                          name={"Email"}
                          placeholder="Email"
                          className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                          onChange={(event) => {
                            handleInnerFormChange(
                              event.target.value,
                              'Login.Email',
                              selectedCommunities?.Login
                            );
                          }}
                          value={selectedCommunities?.Login?.Email} />
                      </div>
                    </div>
                    <div className=" w-full">

                      <div className="border-0 font-normal">
                        <input
                          required
                          maxLength={10}
                          type="text"
                          name={"Phone"}
                          placeholder="Phone Number"
                          pattern="\d{10}"
                          className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                          onChange={(event) => {
                            handleInnerFormChange(
                              event.target.value.replace(/\D/g, ''),
                              'Login.Phone',
                              selectedCommunities?.Login
                            );
                          }}
                          value={selectedCommunities?.Login?.Phone} />
                        {selectedCommunities?.Phone && selectedCommunities?.Phone?.length < 10 && (
                          <span className="text-red-600 text-xs">
                            Please enter a valid number.
                          </span>
                        )}
                      </div>

                    </div>

                  </div>
                )}
                {!selectedCommunities?.IsExistingUser && (
                  <div className="flex flex-row space-x-2 ">
                    <div className=" w-full">

                      <div className="border-0 font-normal">
                        <input
                          required
                          type="text"
                          name={"address1"}
                          placeholder="Building"
                          className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                          onChange={(event) => {
                            handleInnerFormChange(
                              event.target.value,
                              'PrimaryAddress.address1',
                              selectedCommunities?.PrimaryAddress
                            );
                          }}
                          value={selectedCommunities?.PrimaryAddress?.address1} />
                      </div>
                    </div>
                    <div className=" w-full">

                      <div className="border-0 font-normal">
                        <input
                          required
                          type="text"
                          name={"address2"}
                          placeholder="Locality"
                          className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                          onChange={(event) => {
                            handleInnerFormChange(
                              event.target.value,
                              'PrimaryAddress.address2',
                              selectedCommunities?.PrimaryAddress
                            );
                          }}
                          value={selectedCommunities?.PrimaryAddress?.address2} />
                      </div>
                    </div>

                  </div>
                )}
                {!selectedCommunities?.IsExistingUser && (
                  <div className="flex flex-row space-x-2 ">
                    <div className=" w-full">

                      <div className="border-0 font-normal">
                        <input
                          required
                          type="text"
                          name={"city"}
                          placeholder="City"
                          className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                          onChange={(event) => {
                            handleInnerFormChange(
                              event.target.value,
                              'PrimaryAddress.city',
                              selectedCommunities?.PrimaryAddress
                            );
                          }}
                          value={selectedCommunities?.PrimaryAddress?.city} />
                      </div>
                    </div>
                    <div className=" w-full">

                      <div className="border-0 font-normal">
                        <input
                          required
                          type="text"
                          name={"ZipPostalCode"}
                          placeholder="Pincode"
                          className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                          onChange={(event) => {
                            handleInnerFormChange(
                              event.target.value,
                              'PrimaryAddress.ZipPostalCode',
                              selectedCommunities?.PrimaryAddress
                            );
                          }}
                          value={selectedCommunities?.PrimaryAddress?.ZipPostalCode} />
                      </div>
                    </div>

                  </div>
                )}
                {!selectedCommunities?.IsExistingUser && (

                  <div className="flex flex-row space-x-2">

                    <div className="w-full">
                      <div className="border-0 font-normal">
                        <select
                          required
                          name="country"
                          className="w-full py-3 px-3 border-b-2 border-black text-base"
                          onChange={(event) => handleInnerFormChange(event.target.value, 'PrimaryAddress.CountryId',
                            selectedCommunities?.PrimaryAddress
                          )}
                          value={selectedCommunities?.PrimaryAddress?.CountryId || ''}
                        >
                          <option value="" disabled hidden>Select Country</option>

                          {countriesItem.map((country: any) => (
                            <option key={country.Id} value={country.Id}>{country.Name}</option>
                          ))}

                        </select>
                      </div>
                    </div>


                    <div className="w-full">
                      <div className="border-0 font-normal">
                        <select
                          required
                          name="StateProvinceId"
                          className="w-full py-3 px-3 border-b-2 border-black text-base"
                          onChange={(event) => handleInnerFormChange(event.target.value, 'PrimaryAddress.StateProvinceId',
                            selectedCommunities?.PrimaryAddress
                          )}
                          value={selectedCommunities?.PrimaryAddress?.StateProvinceId || ''}
                        >
                          <option value="" disabled hidden>Select State</option>
                          {statesItem?.length > 0 ? (
                            statesItem.map((state, index) => (
                              <option key={index} value={state.Id}>
                                {state.Name}
                              </option>
                            ))
                          ) : (
                            <option value="" disabled>No states available</option>
                          )}
                        </select>
                      </div>
                    </div>
                  </div>
                )}
                <div className="flex flex-row space-x-2">
                  <div className="w-full pt-2">
                    <div className="font-normal">
                      <select
                        required
                        name="program"
                        className="w-full py-3 px-3 border-b-2 border-black text-base"
                        onChange={(event) => handleChange(event.target.value, 'CommunityId')}
                        value={selectedCommunities?.CommunityId || ''}
                      >
                        <option value="" disabled hidden>
                          Select a Communities
                        </option>
                        {communitiesList?.result?.items?.length > 0 ? (
                          communitiesList.result.items.map((program, index) => (
                            <option key={index} value={program.Id}>
                              {program.Name}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            No Communities available now
                          </option>
                        )}
                      </select>
                    </div>
                  </div>
                </div>

              </div>
              {/* <div className="text-[#405578]  text-[9px] pt-3">Wrong weight and sized will seized ypur package + Rs500 penality</div> */}

								<div className={`${isButtonLoading ? 'bg-primary/70' : 'bg-primary'} px-5 flex w-full flex-row items-center justify-center mt-5 mb-10 rounded-lg`}>
                <div

                  onClick={handleSubmit}
                  className=" flex-row flex items-center justify-center text-light text-base my-3 font-bold cursor-pointer"
                >
                  Subscribe
                  <div className={`pl-2 ${isButtonLoading ? 'visible' : 'invisible'}`}>
                    <RotatingLines
                      visible={true}
                      width={'20'}
                      strokeColor="#fff"
                      strokeWidth="6"
                      animationDuration="0.75"
                      ariaLabel="rotating-lines-loading"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
      <div className="flex w-full py-10">
        <div className="swiper p-4 w-full" id="slider5">
          <div className="swiper-wrapper w-full">
            <Swiper
              navigation={{
                nextEl: '.swiper-button-next-ex5',
                prevEl: '.swiper-button-prev-ex5',
              }}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                1536: {
                  slidesPerView: 4,
                  spaceBetween: 10,
                },
                1280: {
                  slidesPerView: 4,
                  spaceBetween: 10,
                },
                1024: {
                  slidesPerView: 5,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                640: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                320: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
              }}
            >
              {dataToRender.map((item: any, i: any) => {
                return (
                  <SwiperSlide key={i}>
                    <ProgramCard
                      communityDetails={item} />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </div>
      </div>
    </>



  );
}
